// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Label, required "*", hint and error text come from CustomFormField */

.rdg-options {
  display: flex;
  gap: 10px;
}

.rdg-options.rdg-row {
  flex-direction: row;
  flex-wrap: wrap;
}

.rdg-options.rdg-column {
  flex-direction: column;
}

.rdg-option {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: var(--cui-control-height);
  margin: 0;
  padding: 8px 12px;
  border: var(--cui-border-width) solid var(--cui-border);
  border-radius: var(--cui-radius);
  background: var(--cui-bg);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: border-color var(--cui-transition), background var(--cui-transition);
}

.rdg-option:hover:not(.rdg-option-disabled) {
  border-color: var(--cui-border-hover);
  background: var(--cui-primary-soft);
}

.rdg-option-selected {
  border-color: var(--cui-primary);
  background: var(--cui-primary-soft);
}

.rdg-option-disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

/* Error: red border on every option + red dot ring */
.rdg-error .rdg-option,
.rdg-error .rdg-option:hover {
  border-color: var(--cui-danger);
}

.rdg-error .rdg-dot {
  border-color: var(--cui-danger);
}

/* Hide the native input visually but keep it accessible/clickable */
.rdg-input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
}

.rdg-dot {
  position: relative;
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid var(--cui-border);
  background: var(--cui-bg);
  transition: border-color var(--cui-transition);
}

.rdg-dot::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--cui-primary);
  transform: translate(-50%, -50%) scale(0);
  transition: transform 0.15s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.rdg-input:checked + .rdg-dot {
  border-color: var(--cui-primary);
}

.rdg-input:checked + .rdg-dot::after {
  transform: translate(-50%, -50%) scale(1);
}

.rdg-input:focus-visible + .rdg-dot {
  box-shadow: 0 0 0 3px var(--cui-primary-ring);
}

.rdg-text {
  font-size: var(--cui-font-size);
  color: var(--cui-text);
  font-weight: 500;
}

.rdg-option-selected .rdg-text {
  color: var(--cui-primary);
  font-weight: 600;
}

/* Phones: options take the full row so they're easy to tap */
@media (max-width: 576px) {
  .rdg-options.rdg-row .rdg-option {
    flex: 1 1 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component/CustomRadioGroup/CustomRadioGroup.css"],"names":[],"mappings":"AAAA,uEAAuE;;AAEvE;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;EACrC,SAAS;EACT,iBAAiB;EACjB,uDAAuD;EACvD,gCAAgC;EAChC,yBAAyB;EACzB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,gFAAgF;AAClF;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,qDAAqD;AACrD;;EAEE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA,oEAAoE;AACpE;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,8BAA8B;EAC9B,yCAAyC;EACzC,6DAA6D;AAC/D;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,6DAA6D;AAC7D;EACE;IACE,cAAc;EAChB;AACF","sourcesContent":["/* Label, required \"*\", hint and error text come from CustomFormField */\n\n.rdg-options {\n  display: flex;\n  gap: 10px;\n}\n\n.rdg-options.rdg-row {\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n\n.rdg-options.rdg-column {\n  flex-direction: column;\n}\n\n.rdg-option {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-height: var(--cui-control-height);\n  margin: 0;\n  padding: 8px 12px;\n  border: var(--cui-border-width) solid var(--cui-border);\n  border-radius: var(--cui-radius);\n  background: var(--cui-bg);\n  cursor: pointer;\n  user-select: none;\n  transition: border-color var(--cui-transition), background var(--cui-transition);\n}\n\n.rdg-option:hover:not(.rdg-option-disabled) {\n  border-color: var(--cui-border-hover);\n  background: var(--cui-primary-soft);\n}\n\n.rdg-option-selected {\n  border-color: var(--cui-primary);\n  background: var(--cui-primary-soft);\n}\n\n.rdg-option-disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n/* Error: red border on every option + red dot ring */\n.rdg-error .rdg-option,\n.rdg-error .rdg-option:hover {\n  border-color: var(--cui-danger);\n}\n\n.rdg-error .rdg-dot {\n  border-color: var(--cui-danger);\n}\n\n/* Hide the native input visually but keep it accessible/clickable */\n.rdg-input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.rdg-dot {\n  position: relative;\n  flex-shrink: 0;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: 2px solid var(--cui-border);\n  background: var(--cui-bg);\n  transition: border-color var(--cui-transition);\n}\n\n.rdg-dot::after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  background: var(--cui-primary);\n  transform: translate(-50%, -50%) scale(0);\n  transition: transform 0.15s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.rdg-input:checked + .rdg-dot {\n  border-color: var(--cui-primary);\n}\n\n.rdg-input:checked + .rdg-dot::after {\n  transform: translate(-50%, -50%) scale(1);\n}\n\n.rdg-input:focus-visible + .rdg-dot {\n  box-shadow: 0 0 0 3px var(--cui-primary-ring);\n}\n\n.rdg-text {\n  font-size: var(--cui-font-size);\n  color: var(--cui-text);\n  font-weight: 500;\n}\n\n.rdg-option-selected .rdg-text {\n  color: var(--cui-primary);\n  font-weight: 600;\n}\n\n/* Phones: options take the full row so they're easy to tap */\n@media (max-width: 576px) {\n  .rdg-options.rdg-row .rdg-option {\n    flex: 1 1 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
